import * as React from "react";
import Preview from "components/common/MarkdownEditor/Preview";
const TextVisualization = ({ config, height }) => /* @__PURE__ */ React.createElement(Preview, { value: config == null ? void 0 : config.text, height, noBorder: true, show: true });
export default TextVisualization;
